import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faGitlab } from '@fortawesome/free-brands-svg-icons/faGitlab';
import { faSlack } from '@fortawesome/free-brands-svg-icons/faSlack';
import { faGoogleDrive } from '@fortawesome/free-brands-svg-icons/faGoogleDrive';
import { Pressable, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';

export function PluginButton({ label, onPress, primary, disabled, accessibilityLabel, compact = false }) {
  const { colors } = useTheme();
  return <Pressable accessibilityRole="button" accessibilityLabel={accessibilityLabel || label}
    accessibilityState={{ disabled: !!disabled }} disabled={disabled} onPress={onPress}
    style={({ hovered, pressed }) => [styles.button, compact && { minHeight: 36, paddingVertical: 7, borderRadius: 20 }, { opacity: disabled ? 0.45 : pressed ? 0.7 : 1,
      backgroundColor: primary ? colors.text_color_primary : hovered ? colors.solid_color_tertiary : colors.solid_color_secondary }]}>
    <Text size="s" weight="medium" style={{ color: primary ? colors.solid_color_primary : colors.text_color_primary }}>{label}</Text>
  </Pressable>;
}
export function PluginMark({ entry, size = 40 }) {
  const { colors } = useTheme();
  const brand = { 'github-connected': faGithub, 'gitlab-connected': faGitlab, 'slack-connected': faSlack, 'google-drive-connected': faGoogleDrive }[entry?.id];
  if (brand) return <View style={{ width: size, height: size, backgroundColor: '#fff', borderRadius: Math.max(4, size / 5), alignItems: 'center', justifyContent: 'center' }}>
    <FontAwesomeIcon icon={brand} size={size * 0.82} color={entry.color || '#181818'} />
  </View>;
  return <View style={[styles.mark, { width: size, height: size, borderColor: colors.border_color_secondary }]}>
    <Icon name={entry?.icon || 'grid-2'} size={size / 2} color={entry?.color || '#343434'} />
  </View>;
}

export const styles = StyleSheet.create({
  scroll: { padding: 32, paddingBottom: 64 }, content: { width: '100%', maxWidth: 1000, alignSelf: 'center', gap: 28 },
  heading: { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 16 }, grow: { flex: 1, minWidth: 0, gap: 5 },
  search: { minHeight: 48, flexDirection: 'row', alignItems: 'center', gap: 12, paddingHorizontal: 16, borderWidth: 1, borderRadius: 12 },
  access: { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 14, borderWidth: 1, borderRadius: 12, padding: 18 },
  section: { gap: 16 }, grid: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', gap: 14 },
  catalogItem: { flexDirection: 'row', alignItems: 'center', gap: 14, padding: 16, minHeight: 104, borderWidth: 1, borderRadius: 12 },
  mark: { borderRadius: 11, borderWidth: 1, backgroundColor: '#fff', alignItems: 'center', justifyContent: 'center' },
  button: { paddingHorizontal: 14, paddingVertical: 9, minHeight: 44, justifyContent: 'center', borderRadius: 8, alignSelf: 'flex-start' },
  row: { flexDirection: 'row', alignItems: 'center', gap: 14 }, actions: { flexDirection: 'row', flexWrap: 'wrap', gap: 8 },
  dialog: { flex: 1, minHeight: 0, borderRadius: 16, borderWidth: 1, overflow: 'hidden' },
  dialogHeader: { padding: 20 }, detail: { padding: 20, paddingTop: 0, gap: 16 }, skill: { gap: 4, paddingVertical: 5 },
  connection: { borderWidth: 1, borderRadius: 10, padding: 14, gap: 10 },
  installed: { flexDirection: 'row', flexWrap: 'wrap', gap: 10 }, installedItem: { alignItems: 'center', gap: 6, padding: 12, borderRadius: 10, maxWidth: 180 },
  footer: { borderTopWidth: 1, paddingTop: 24, gap: 10 },
});
